import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import { getDate } from "../../common/DisplayDate";
import getPersonName from "../../common/Name";
import getSsn from "../../common/Ssn";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class ProfessionalLicenses extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const { isSilverReport } = this.props;
      if (isSilverReport) {
        const { node } = this.props;
        if (node && node.length > 0) {
          _.forEach(node, (record, index) => {
            rows.push(
              <Table.Row
                key={`row_prof_lic_address_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> License Number: </Table.Cell>
                <Table.Cell width={5}>
                  {_.get(record, "licenseNumber[0]._", "")}
                </Table.Cell>
                <Table.Cell width={3}>License Type:</Table.Cell>
                <Table.Cell width={5}>
                  {_.get(record, "licenseType[0]._", "")}
                </Table.Cell>
              </Table.Row>
            );
            rows.push(
              <Table.Row
                key={`row_prof_lic_status_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> Expiration Date: </Table.Cell>
                <Table.Cell width={5}>
                  {getDate(_.get(record, "expirationDate[0]"))}
                </Table.Cell>
                <Table.Cell width={2}>Status:</Table.Cell>
                <Table.Cell width={5}>
                  {_.get(record, "licenseStatus[0]._", "")}
                </Table.Cell>
              </Table.Row>
            );
            rows.push(
              <Table.Row
                key={`row_prof_lic_issue_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> Issue Date: </Table.Cell>
                <Table.Cell width={5}>
                  {getDate(_.get(record, "issueDate[0]"))}
                </Table.Cell>
                <Table.Cell width={2}>Source State:</Table.Cell>
                <Table.Cell width={5}>
                  {_.get(record, "licenseState[0]._", "")}
                </Table.Cell>
              </Table.Row>
            );
            recCount += 1;
          });
        } else {
          rows.push(
            <Table.Row key={`no_recs_row`}>
              <Table.Cell colSpan={2}>No Records found</Table.Cell>
            </Table.Row>
          );
        }
      } else {
        const records = _.get(
          props.reportData,
          "personReport.compReportResponse[0].individual[0].professionalLicenses[0].professionalLicense"
        );
        if (records !== undefined) {
          _.forEach(records, (record, index) => {
            const lastName = _.get(record, "name[0].last[0]._");
            const originalName = _.get(record, "originalName[0].full[0]._", "");
            let personName;
            if (lastName !== undefined) {
              personName = getPersonName(
                _.get(record, "name[0].first[0]._", ""),
                _.get(record, "name[0].middle[0]._", ""),
                _.get(record, "name[0].last[0]._", ""),
                props
              );
            }
            const additionalOrigName = _.get(
              record,
              "additionalOrigName[0].full[0]._"
            );
            const companyName = _.get(record, "companyName[0]._");
            rows.push(
              <Table.Row
                key={`row_prof_lic_name_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> Name: </Table.Cell>
                <Table.Cell width={7}>
                  {personName
                    ? (<span>{personName}</span>)
                    : (<span>{originalName}</span>)}
                  {additionalOrigName && (
                    <span>
                      <br />
                      {additionalOrigName}
                    </span>
                  )}
                  {companyName && (
                    <span>
                      <br />
                      {companyName}
                    </span>
                  )}
                </Table.Cell>
                <Table.Cell width={2}>License Type:</Table.Cell>
                <Table.Cell width={3}>
                  {_.get(record, "licenseType[0]._", "")}
                </Table.Cell>
              </Table.Row>
            );

            rows.push(
              <Table.Row
                key={`row_prof_lic_address_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> Address: </Table.Cell>
                <Table.Cell width={8}>
                  <Address
                    addressNode={_.get(record, "address[0]")}
                    {...this.props}
                  />
                </Table.Cell>
                <Table.Cell width={2}>Source State:</Table.Cell>
                <Table.Cell width={3}>
                  {_.get(record, "sourceState[0]._", "")}
                </Table.Cell>
              </Table.Row>
            );

            rows.push(
              <Table.Row
                key={`row_prof_lic_orig_address_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}>Original Address: </Table.Cell>
                <Table.Cell width={8}>
                  <Address
                    addressNode={_.get(record, "originalAddress[0]")}
                    {...this.props}
                  />
                </Table.Cell>
                <Table.Cell width={2}>Profession/Board:</Table.Cell>
                <Table.Cell width={3}>
                  {_.get(record, "professionOrBoard[0]._", "")}
                </Table.Cell>
              </Table.Row>
            );

            rows.push(
              <Table.Row
                key={`row_prof_lic_ssn_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> SSN: </Table.Cell>
                <Table.Cell width={8}>
                  {getSsn(_.get(record, "SSN"), this.props)}
                </Table.Cell>
                <Table.Cell width={2}>Expiration Date:</Table.Cell>
                <Table.Cell width={3}>
                  {getDate(_.get(record, "expirationDate[0]"))}
                </Table.Cell>
              </Table.Row>
            );

            rows.push(
              <Table.Row
                key={`row_prof_lic_status_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> Status: </Table.Cell>
                <Table.Cell width={8}>
                  {_.get(record, "status[0]._", "")}
                </Table.Cell>
                <Table.Cell width={2}>License Number:</Table.Cell>
                <Table.Cell width={3}>
                  {_.get(record, "licenseNumber[0]._", "")}
                </Table.Cell>
              </Table.Row>
            );

            rows.push(
              <Table.Row
                key={`row_prof_lic_last_seen_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> Date Last Seen: </Table.Cell>
                <Table.Cell width={8}>
                  {getDate(_.get(record, "dateLastSeen[0]"))}
                </Table.Cell>
                <Table.Cell width={2}>Issue Date:</Table.Cell>
                <Table.Cell width={3}>
                  {getDate(_.get(record, "issuedDate[0]"))}
                </Table.Cell>
              </Table.Row>
            );
            recCount += 1;
          });
        } else {
          rows.push(
            <Table.Row key={`no_recs_row`}>
              <Table.Cell colSpan={2}>No Records found</Table.Cell>
            </Table.Row>
          );
        }
      }
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Professional Licenses Registered to the Subject"}
        rows={this.state.rows}
      />
    );
  }
}

export default ProfessionalLicenses;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/ProfessionalLicenses.js